/**
 * Shows a loading icon on legal PDF download buttons until the file is ready.
 */

document.addEventListener('click', event => {
  const link = event.target.closest('[data-pdf-download]');

  if (!link || link.getAttribute('aria-busy') === 'true') {
    return;
  }

  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  event.preventDefault();
  link.setAttribute('aria-busy', 'true');
  link.classList.add('is-loading');

  fetch(link.href, { credentials: 'same-origin' })
    .then(response => {
      if (!response.ok) {
        throw new Error('PDF download failed');
      }

      const disposition = response.headers.get('Content-Disposition');

      return response.blob().then(blob => ({ blob, disposition }));
    })
    .then(({ blob, disposition }) => {
      const filename = filenameFromDisposition(disposition);
      const objectUrl = URL.createObjectURL(blob);
      const download = document.createElement('a');

      download.href = objectUrl;
      download.download = filename;
      document.body.appendChild(download);
      download.click();
      download.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
    })
    .catch(() => {
      window.location.assign(link.href);
    })
    .finally(() => {
      link.removeAttribute('aria-busy');
      link.classList.remove('is-loading');
    });
});

/**
 * @param {string|null} disposition
 */
function filenameFromDisposition(disposition) {
  if (!disposition) {
    return 'document.pdf';
  }

  const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);

  if (!match) {
    return 'document.pdf';
  }

  try {
    return decodeURIComponent(match[1] || match[2] || '') || 'document.pdf';
  } catch {
    return 'document.pdf';
  }
}
